import React, { useState, useEffect } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Typography,
  TextField,
  Snackbar,
  Alert,
} from '@mui/material';
import axios from 'axios';
import StockTable from './StockTable';
import { BRAND } from '../constants/brand';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`shop-tabpanel-${index}`}
      aria-labelledby={`shop-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component={'span'}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function StockAllocation() {
  const [tabIndex, setTabIndex] = useState(0);
  const [shop1Stock, setShop1Stock] = useState([]);
  const [shop1SearchTerm, setShop1SearchTerm] = useState('');
  const [shop1SearchItemId, setShop1SearchItemId] = useState('');

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [alertMessage, setAlertMessage] = useState('');

  useEffect(() => {
    fetchStockData();
  }, []);

  const fetchStockData = async () => {
    try {
      const shop1Response = await axios.get('https://serverukautotech.ccsoftwares.com/stock/getShop1Stock');
      setShop1Stock(shop1Response.data);
    } catch (error) {
      console.error('Error fetching stock data:', error);
      setAlertSeverity('error');
      setAlertMessage('Failed to fetch stock data.');
      setAlertOpen(true);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleAlertClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertOpen(false);
  };

  const filterStockData = (stockData, searchTerm, searchItemId) => {
    return stockData.filter((item) =>
      item.itemname.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (searchItemId === '' || item.itemid.toString() === searchItemId)
    );
  };

  return (
    <Box sx={{ width: '100%', paddingTop: '50px' }}>
      <Tabs value={tabIndex} onChange={handleTabChange} centered>
        <Tab label={`${BRAND.name} Inventory`} />
      </Tabs>

      <TabPanel value={tabIndex} index={0}>
        <Typography variant="h6">{`${BRAND.name} Stock`}</Typography>
        <TextField
          label="Search Item by Name"
          variant="outlined"
          fullWidth
          sx={{ mt: 2, mb: 2 }}
          value={shop1SearchTerm}
          onChange={(e) => setShop1SearchTerm(e.target.value)}
        />
        <TextField
          label="Search Item Barcode"
          variant="outlined"
          fullWidth
          sx={{ mb: 2 }}
          value={shop1SearchItemId}
          onChange={(e) => setShop1SearchItemId(e.target.value)}
        />
        <StockTable
          stockData={filterStockData(shop1Stock, shop1SearchTerm, shop1SearchItemId)}
        />
      </TabPanel>

      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleAlertClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleAlertClose} severity={alertSeverity} sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default StockAllocation;
